import axios from "./axios";
import language from "./language";
export default async (phone_area_code: string, phone: string, verification_code: string, new_password: string) => {
    return await axios.post("/user/reset", {
        phone_area_code,
        phone,
        verification_code,
        new_password,
        lang: language(),
     //   recaptcha_token: await window.grecaptcha.execute('6LdoWDIpAAAAAEaCpBaxQj_fm81y7SjBAZeAd_7f', { action: 'submit' })
    });
}